import React, {Component} from 'react';
import { SingleDatePicker } from "react-dates"; 
import moment from 'moment';
import LabelComponent from './LabelComponent';

import { 
    Calendar4
 } from 'react-bootstrap-icons';

const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';


export default class DateSingleCalendar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: moment()
        }
    }

    isOutsideRange = (day) => {
        if(this.props.past) {
            return false;
        } else {
            return day.isBefore(moment(), 'day');
        }      
    }

    render() {
        return (
            <>
                <div>
                    <LabelComponent 
                        label={this.props.label ? this.props.label : "Date"}
                        labelIcon={<Calendar4 size={16} className="mb-1 me-1" />}
                    />
                </div>
                <div>
                <SingleDatePicker
                    date={this.props.startDate ? this.props.startDate : this.state.startDate}
                    onDateChange={(date) => this.props.handleDateChange(date)}
                    focused={this.state.focused}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    orientation={orientation}
                    small={true}
                    displayFormat="DD/MM/YYYY"
                    isOutsideRange={(day) => this.isOutsideRange() }
                    isDayHighlighted={(day) => {
                        if(this.props.isDayHighlightedData.indexOf(moment(day).format('YYYY-MM-DD')) > -1) {
                            return true;
                        }
                        return false;
                    }}
                />
                </div>
            </>
        )
    }
}